function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
import React from "react";
import PropTypes from "prop-types";

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/**
 * Footer
 */

var Footer = function (_React$Component) {
  _inherits(Footer, _React$Component);

  /**
   * constructor - Just a standard constructor.
   */
  function Footer(props) {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, _React$Component.call(this, props));
  }

  /**
   * render - Standard renderer.
   */


  Footer.prototype.render = function render() {
    return React.createElement(
      "footer",
      this.props,
      this.props.children
    );
  };

  return Footer;
}(React.Component);

Footer.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
  // style: PropTypes.object, // eslint-disable-line
  // className: PropTypes.string, // eslint-disable-line
  // unset: PropTypes.bool,
  // classes: PropTypes.object, // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types
} : {};

Footer.defaultProps = {
  // style: {},
  // unset: false,
};

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Export
// ----------------------------------------------------------------------------
export default Footer;